<template>
    <div>

            <!-- @mouseover="update_src($event,1)"
            @mouseleave="update_src($event,1)" -->
        <div
            class="row d-flex justify-content-start align-items-center"
            style="cursor:pointer;"
            :style="isMobile ? 'width:350px' : 'width:450px'"
            @click="configuratorSelected(infoConfigurator)"
            @mouseover="update_src($event,1)"
            @mouseleave="update_src($event,1)"
        >
                <!-- @mouseover="update_src($event,2)"
                @mouseleave="update_src($event,2)" -->
            <img
                :id=" 'img_' + infoConfigurator.id"
                :src="infoConfigurator.image"
                alt
                class="ml-2 mr-3"
                :style="isMobile ? 'max-height: 90px; width: auto;' : 'max-height: 175px; width: auto;'"
                @mouseover="update_src($event,2)"
                @mouseleave="update_src($event,2)"
            />

                <!-- @mouseover="update_src($event,3)"
                @mouseleave="update_src($event,3)" -->
            <div
                style="max-width:200px; color:black"
                class="mr-1 mt-3"
                @mouseover="update_src($event,3)"
                @mouseleave="update_src($event,3)"
            >
                <p style="text-align:left; font-weight: bold">
                    {{ infoConfigurator.name }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";

export default {
    name: "configuratorComponent",
    props: ["infoConfigurator"],
    created() {
        app.currentConfiguration.stage = 1;
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    data() {
        return {
            window: { width: 0, height: 0 }
        };
    },
    computed: {
        isMobile: function() {
            let a = this.window.width < 600;
            return a;
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        update_src: function(event, el) {
            let target = event.target;
            //  console.log(event);

            if (event.type === "mouseover") {
                if (el === 1 && target.tagName === "DIV") {
                    target.children[0].src = this.infoConfigurator.image_hover;
                } else if (el === 2 && target.tagName === "IMG") {
                    target.src = this.infoConfigurator.image_hover;
                } else if (el === 3 && target.tagName === "DIV") {
                    target.parentNode.children[0].src = this.infoConfigurator.image_hover;
                }
            } else if (event.type === "mouseleave") {
                if (el === 1 && target.tagName === "DIV") {
                    target.children[0].src = this.infoConfigurator.image;
                } else if (el === 2 && target.tagName === "IMG") {
                    target.src = this.infoConfigurator.image;
                } else if (el === 3 && target.tagName === "DIV") {
                    target.parentNode.children[0].src = this.infoConfigurator.image;
                }
            }
        },
        navigateToProductFamilies: function(id, event) {
            this.$router.push({ name: "2", params: { id } });
        },
        //navigateToProductFamilies: function(id){this.$router.push({ path: `/2/${id}`})}

        configuratorSelected: function(configurator) {
            this.$emit("configuratorSelected", configurator);
        }
    }
};
</script>

<style lang="scss">
</style>
